import React, {useContext, useEffect, useRef, useState} from 'react';
import {isFilterSelected} from '../functions/filter';
import {FilterContext} from '../context/filterContext';
import SearchIcon from '../../../assests/img/search.svg?react';
import '../../../assests/css/dropdownfilter.scss';
import classNames from 'classnames';

export interface filterData{
    id: number,
    value: string,
    abbreviation?: string,
    color?: string,
    companyStateId?: number,
    logo?: string,
    groupId?: number
}

export interface filterType {
     filterType: 'coverage' | 'carrier' | 'facilityType' | 'wholesaler' | 'states',
}

export interface dropdownFilterProps {
    filterName: string,
    dropdownData: filterData[],
    filterType: 'coverage' | 'carrier' | 'facilityType' | 'wholesaler' | 'states',
    currentFilter?: filterData[],
    disableFilter?: boolean
}

export default function DropdownFilter(props: dropdownFilterProps) {

    const {filterContent, setFilterContent} = useContext(FilterContext);
    const dropdownRef= useRef<HTMLDivElement>(null);
    const [showDropdown, setShowDropdown]= useState(false);
    const [filter, setFilter]= useState<filterData[]>([
    ]);
    const [searchQuery, setSearchQuery]= useState('');

    const {filterName, filterType}=props;

    const [dropdownData, setDropdownData]=useState(props.dropdownData);

    const handleOnClickDropdown= ()=> setShowDropdown(!showDropdown);

    const handleClickOutside=(event: MouseEvent)=> {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)) {
            setShowDropdown(false);
        }
    }

    const clearFilter=(e: React.MouseEvent<HTMLDivElement>)=> {
        e.stopPropagation();
        setFilter([
        ]);
        setFilterContent({...filterContent, [filterType]: []});
    }

    const getFilterText = (filter: filterData[]) => filter.map((eachFilter)=>
        eachFilter.value.toString()).filter((data)=> data!=='All').join(', ');

    const handleFilter = (id: number, value: string) => {
        const temp = [...filter];
        const index = temp.findIndex((data)=> data.id === id);
        if (index >= 0) {
            if (id === 0) {temp.splice(0, temp.length);}
            else {
                const index = filter.findIndex((data)=> data.id === id);
                temp.splice(index, 1);
            }
        } else {
            if (id === 0) {
                temp.splice(0, temp.length);
                temp.push(...dropdownData);
            }
            else {temp.push({id, value});}
        }
        if (temp.length !== dropdownData.length) {
            const index = temp.findIndex((data)=> data.id === 0);
            if (index >=0) {temp.splice(index, 1);}
            else if (index === -1 &&
                temp.length === (dropdownData.length-1)) {temp.push(
                {id: 0, value: 'All'});}
        }
        setFilter(temp);
        setFilterContent({...filterContent, [filterType]: temp});
    }

    const handleSearch = (e: React.FormEvent<HTMLInputElement>) => {
        const searchText = e.currentTarget.value;
        setSearchQuery(searchText);
        if (searchText.length) {
            const temp = [...dropdownData];
            const filetedData = temp.filter((data)=>
                data.value.toLowerCase().includes(searchText.toLowerCase()));
            setDropdownData(filetedData);
        } else {
            setDropdownData(props.dropdownData);
        }
    }

    useEffect(() => {
        if (showDropdown === false) {
            setSearchQuery('');
            setDropdownData(props.dropdownData);
        }
        if (props.currentFilter) {
            setFilter(props.currentFilter);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [
        showDropdown, props.dropdownData, props.currentFilter
    ]);
    
    return (
        <>
        <div className={classNames('dropdown-filter-container',
            props.disableFilter? 'disable-filter': '')}>
            <div className="dropdown-filter-name">{filterName}</div>
            <div className={classNames('dropdown-filtered-text-container',
                props.disableFilter? 'disable-filter': '')}
                onClick={props.disableFilter?
                ()=> null: ()=> handleOnClickDropdown()}>
                {filter.length? <div className="dropdown-filtered-by">
                        {getFilterText(filter)}
                    </div>: <div className="dropdown-filtered-by-placeholder">
                        Select {filterName}
                    </div>}
                <div className="dropdown-filter-clear"
                    onClick={props.disableFilter?
                    ()=> null: (e)=> clearFilter(e)}>&#x2715;
                </div>
                <div className="dropdown-filter-icon"></div>
            </div>
            {showDropdown? <div className="dropdown-filter-menu" ref={dropdownRef}>
                <div className="dropdown-filter-search">
                    <SearchIcon width="14px" height="14px"/>
                    <input type="text" className="dropdown-filter-search-text" placeholder="Search"
                        onChange={(e)=>
                            handleSearch(e)} value={searchQuery}></input>
                </div>
                <div className="dropdown-filter-items">
                    {dropdownData.map((data, index)=> {
                        return (
                            <div onClick={()=> handleFilter(data.id, data.value)} className="dropdown-filter-item" key={`${data.id}-${index}`}>
                                <input type="checkbox" id={data.id.toString()}
                                onChange={()=>
                                    handleFilter(data.id, data.value)}
                                checked={isFilterSelected(data.id, filter)}
                                className="dropdown-filter-checkbox"/>
                                <span className="dropdown-filter-text">
                                    {`${data.value} ${data.abbreviation? ` - ${data.abbreviation}`: ''}`}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>: null}
        </div>
        </>
    );

}